import { useMutation } from '@apollo/client';
import { REMOVE_FROM_WORLD_MAP_SET } from 'graphql/mutation/worldMutation';
import {
    RemoveFromWorldMapSet,
    RemoveFromWorldMapSetVariables
} from 'graphql/mutation/__generated__/RemoveFromWorldMapSet';
import { WorldMapSets_worldMap_worldMapSets } from 'graphql/query/__generated__/WorldMapSets';
import { cacheRemoveMarkerFromWorldMapSet } from 'hooks/marker/cacheUpdateMethods';
import { useWorldMapLocalStorage } from 'libs/hooks/ownership/useWorldMapLocalStorage';

export const useRemoveMarkerFromSetMutation = () => {
    const [mutation] = useMutation<RemoveFromWorldMapSet, RemoveFromWorldMapSetVariables>(
        REMOVE_FROM_WORLD_MAP_SET
    );
    const { getTokenForMapId } = useWorldMapLocalStorage();

    const sendMutation = (params: {
        mapSet: WorldMapSets_worldMap_worldMapSets;
        markerId: string;
        worldMapId: string;
    }) => {
        mutation({
            variables: {
                worldMapSetId: params.mapSet.worldMapSetId,
                worldMapMarkerId: params.markerId,
                token: getTokenForMapId(params.worldMapId)
            },
            optimisticResponse: {
                removeFromWorldMapSet: {
                    ...params.mapSet,
                    markers: params.mapSet.markers.filter(
                        (e) => e.worldMapMarkerId !== params.markerId
                    )
                }
            },
            update: (cache) => {
                cacheRemoveMarkerFromWorldMapSet(
                    cache,
                    params.markerId,
                    params.mapSet.worldMapSetId
                );
            }
        });
    };

    return [sendMutation];
};
